/* eslint-disable react-hooks/exhaustive-deps,no-param-reassign,react/jsx-props-no-spreading */
import React, { useEffect, useState } from "react";
import { Table, Col, Row, Button, Pagination, Space, Checkbox, Tooltip } from "antd";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import isEmpty from "lodash/isEmpty";
import pick from "lodash/pick";
import { useRouteMatch } from "react-router-dom";
import { useHistory } from "react-router";
import {
  toDisplayFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import TablePageSelect from "../TablePageSelect/TablePageSelect";
import AuthService from "../../services/AuthService";
import { formatDate, round } from "../../lib/utils";
import { exportToXLS } from "../../store/slices/xlsExport";
import { adjustmentIcon, chargeIcon } from "../../lib/icons";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_CHARGES_WRITE } from "../../lib/const/permissions";
import { limitText } from "../../lib/utils/limitText";
import SpanNumberFormat from "../common/SpanNumberFormat";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";
import { useAppDispatch, useAppSelector } from "../..";
import { ChargesSearchFilters } from "./ChargesSearchFilters/ChargesSearchFilters";
import { useLoading } from "../../lib/hooks/useLoading";

const Charges = (props) => {
  const {
    data,
    checked,
    chargesData,
    getValueChargesPagingAndFilters,
    resetSearchCharges,
    handleSearchCharges,
    toggleZeroCharges,
    chargeParams,
    handlePageSize,
    form,
    selectedRowKeys,
    setSelectedRowKeys,
    chargesSearchParams,
    fetchChargesAll,
    clientType,
    setClientType,
  } = props;

  const localStore = JSON.parse(sessionStorage.getItem("chargeFilters"));

  const { rateType, rateTypeLoading } = useAppSelector((state) => state.rtkDictionaries);
  const { companyIdentityAttribute } = useAppSelector((state) => state.tenants.tenantProperties);
  const chargesDataLoading = useAppSelector((state) => state.charges.chargesMassLoading);
  const [filtersCollapseState, setFiltersCollapseState] = useState("unfolded");
  const [chargeColumns, setChargeColumns] = useState("");
  const { url } = useRouteMatch();
  const history = useHistory();
  const dispatch = useAppDispatch();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const resetSearchPaymentsAndResetSetSelectedRowKeys = () => {
    resetSearchCharges();
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    setChargeColumns(localStore?.chargeColumns);
  }, []);

  const getTableHeight = () => (filtersCollapseState === "unfolded" ? `${40}vh` : `${64}vh`);

  const checkHideColumns = (name) => {
    let check = true;
    const findIndex =
      localStore?.chargeColumns &&
      localStore?.chargeColumns.findIndex((item) => item.title === name);
    if (findIndex !== -1) {
      check = false;
    }
    return check;
  };

  const columnsWidths = {
    chargeId: "100px",
    clientFullName: "140px",
    serviceTypeName: "140px",
    rateMode: "140px",
    offeringName: "140px",
    rateTypeId: "140px",
    period: "100px",
    chargePrice: "85px",
    chargeUnits: "100px",
    chargeAmount: "100px",
    chargeName: "140px",
    adjustmentTypeId: "140px",
    invoiceExtNum: "140px",
    billNumber: "140px",
    invoicePayStatus: "140px",
    invoiceAmount: "100px",
    invoicePeriod: "100px",
    invoiceDate: "100px",
    billPayStatus: "140px",
    billAmount: "100px",
    billPeriod: "100px",
    billFromDate: "100px",
  };

  const [columns, setColumns] = useState([
    {
      title: "ID начисления",
      dataIndex: "chargeId",
      key: "chargeId",
      hidden: true,
      width: columnsWidths.chargeId,
    },
    {
      title: "Клиент",
      dataIndex: "clientFullName",
      key: "clientFullName",
      hidden: localStore?.chargeColumns ? checkHideColumns("Клиент") : false,
      width: columnsWidths.clientFullName,
    },
    {
      title: "Тип продукта",
      dataIndex: "serviceTypeName",
      key: "serviceTypeName",
      hidden: localStore?.chargeColumns ? checkHideColumns("Тип продукта") : false,
      width: columnsWidths.serviceTypeName,
    },
    {
      title: "Вид цены",
      dataIndex: "rateMode",
      key: "rateMode",
      hidden: localStore?.chargeColumns ? checkHideColumns("Вид цены") : true,
      width: columnsWidths.rateMode,
    },
    {
      title: "Предложение",
      dataIndex: "offeringName",
      key: "offeringName",
      hidden: localStore?.chargeColumns ? checkHideColumns("Предложение") : false,
      width: columnsWidths.offeringName,
    },
    {
      title: "Тип цены",
      dataIndex: "rateTypeId",
      key: "rateTypeId",
      hidden: localStore?.chargeColumns ? checkHideColumns("Тип цены") : false,
      width: columnsWidths.rateTypeId,
    },
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      hidden: localStore?.chargeColumns ? checkHideColumns("Период") : false,
      render: (period) => (
        <>
          {period.map((item) => (
            <span key={item.id}>
              {item.date}
              {`${item.id === 1 ? " - " : ""} `}
            </span>
          ))}
        </>
      ),
      width: columnsWidths.period,
    },
    {
      title: "Цена",
      dataIndex: "chargePrice",
      key: "chargePrice",
      hidden: localStore?.chargeColumns ? checkHideColumns("Цена") : false,
      render: (chargePrice) => SpanNumberFormat({ amount: chargePrice }),
      width: columnsWidths.chargePrice,
    },
    {
      title: "Количество",
      dataIndex: "chargeUnits",
      key: "chargeUnits",
      hidden: localStore?.chargeColumns ? checkHideColumns("Количество") : false,
      render: (chargeUnits) => SpanNumberFormat({ amount: chargeUnits, fractSize: 0 }),
      width: columnsWidths.chargeUnits,
    },
    {
      title: "Сумма",
      dataIndex: "chargeAmount",
      key: "chargeAmount",
      hidden: localStore?.chargeColumns ? checkHideColumns("Сумма") : false,
      render: (chargeAmount) => SpanNumberFormat({ amount: chargeAmount }),
      width: columnsWidths.chargeAmount,
    },
    {
      title: "Номенклатура",
      dataIndex: "chargeName",
      key: "chargeName",
      hidden: localStore?.chargeColumns ? checkHideColumns("Номенклатура") : true,
      render: (chargeName) => <Tooltip title={chargeName}>{limitText(chargeName, 30)}</Tooltip>,
      width: columnsWidths.chargeName,
    },
    {
      title: "Начисление/Корректировка",
      dataIndex: "adjustmentTypeId",
      key: "adjustmentTypeId",
      hidden: localStore?.chargeColumns ? checkHideColumns("Начисление/Корректировка") : false,
      width: columnsWidths.adjustmentTypeId,
    },
    {
      title: "Номер СФ",
      dataIndex: "invoiceExtNum",
      key: "invoiceExtNum",
      hidden: localStore?.chargeColumns ? checkHideColumns("Номер СФ") : false,
      width: columnsWidths.invoiceExtNum,
    },
    {
      title: "Номер счета",
      dataIndex: "billNumber",
      key: "billNumber",
      hidden: localStore?.chargeColumns ? checkHideColumns("Номер счета") : false,
      width: columnsWidths.billNumber,
    },
    {
      title: "Статус СФ",
      dataIndex: "invoicePayStatus",
      key: "invoicePayStatus",
      hidden: localStore?.chargeColumns ? checkHideColumns("Статус СФ") : true,
      width: columnsWidths.invoicePayStatus,
    },
    {
      title: "Сумма СФ",
      dataIndex: "invoiceAmount",
      key: "invoiceAmount",
      hidden: localStore?.chargeColumns ? checkHideColumns("Сумма СФ") : true,
      render: (invoiceAmount) => SpanNumberFormat({ amount: invoiceAmount }),
      width: columnsWidths.invoiceAmount,
    },
    {
      title: "Период СФ",
      dataIndex: "invoicePeriod",
      key: "invoicePeriod",
      hidden: localStore?.chargeColumns ? checkHideColumns("Период СФ") : true,
      render: (invoicePeriod) => (
        <>
          {invoicePeriod.map((item) => (
            <span key={item.id}>
              {item.date}
              {`${item.id === 1 ? " - " : ""} `}
            </span>
          ))}
        </>
      ),
      width: columnsWidths.invoicePeriod,
    },
    {
      title: "Дата СФ",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      hidden: localStore?.chargeColumns ? checkHideColumns("Дата СФ") : true,
      width: columnsWidths.invoiceDate,
    },
    {
      title: "Статус оплаты счета",
      dataIndex: "billPayStatus",
      key: "billPayStatus",
      hidden: localStore?.chargeColumns ? checkHideColumns("Статус оплаты счета") : true,
      width: columnsWidths.billPayStatus,
    },
    {
      title: "Сумма счета",
      dataIndex: "billAmount",
      key: "billAmount",
      hidden: localStore?.chargeColumns ? checkHideColumns("Сумма счета") : true,
      render: (billAmount) => SpanNumberFormat({ amount: billAmount }),
      width: columnsWidths.billAmount,
    },
    {
      title: "Период счета",
      dataIndex: "billPeriod",
      key: "billPeriod",
      hidden: localStore?.chargeColumns ? checkHideColumns("Период счета") : true,
      render: (billPeriod) => (
        <>
          {billPeriod.map((item) => (
            <span key={item.id}>
              {item.date}
              {`${item.id === 1 ? " - " : ""} `}
            </span>
          ))}
        </>
      ),
      width: columnsWidths.billPeriod,
    },
    {
      title: "Дата счета",
      dataIndex: "billFromDate",
      key: "billFromDate",
      hidden: localStore?.chargeColumns ? checkHideColumns("Дата счета") : true,
      width: columnsWidths.billFromDate,
    },
  ]);

  const filterColumns = [...columns].filter((item) => !item.hidden);

  let tableData;

  if (checkIsLoaded(chargesDataLoading) && filterColumns && filterColumns.length) {
    tableData =
      data &&
      data.map((item) => ({
        key: item.serialNumber,
        clientFullName: item.clientFullName || String(item.accountId) || "",
        rateTypeId:
          item.rateTypeId && checkIsLoaded(rateTypeLoading) && rateType
            ? rateType.find((find) => find?.id === item.rateTypeId)?.name
            : "-",
        serviceTypeName:
          !item.serviceTypeName && item.isAdjustment === 1
            ? item?.chargeName
            : item?.serviceTypeName,
        rateMode: item.rateMode,
        offeringName: item.offeringName,
        period: [
          {
            id: 1,
            date: item.chargePeriodFrom ? toDisplayFormat(item.chargePeriodFrom) : "",
          },
          {
            id: 2,
            date: item.chargePeriodTo ? toDisplayFormat(item.chargePeriodTo) : "",
          },
        ],
        chargeUnits: item.chargeUnits,
        chargeAmount: item?.chargeAmount && round(item?.chargeAmount),
        chargePrice: item?.chargePrice && round(item?.chargePrice),
        chargeName: item.chargeName,
        adjustmentTypeId:
          Number(item.adjustmentTypeId) === 0 ? (
            <Tooltip title="Начисление">{chargeIcon()}</Tooltip>
          ) : (
            <Tooltip title="Корректировка">{adjustmentIcon()}</Tooltip>
          ),
        invoiceExtNum: item.invoiceExtNum,
        billNumber: item.billNumber,
        invoicePayStatus: item.invoicePayStatus,
        invoiceAmount: item?.invoiceAmount && round(item?.invoiceAmount),
        invoicePeriod: [
          {
            id: 1,
            date: item.invoicePeriodFrom ? toDisplayFormat(item.invoicePeriodFrom) : "",
          },
          {
            id: 2,
            date: item.invoicePeriodTo ? toDisplayFormat(item.invoicePeriodTo) : "",
          },
        ],
        invoiceDate: item.invoiceDate ? toDisplayFormat(item.invoiceDate) : "",
        billPayStatus: item.billPayStatus,
        billAmount: item?.billAmount && round(item?.billAmount),
        billPeriod: [
          {
            id: 1,
            date: item.billPeriodFrom ? toDisplayFormat(item.billPeriodFrom) : "",
          },
          {
            id: 2,
            date: item.billPeriodTo ? toDisplayFormat(item.billPeriodTo) : "",
          },
        ],
        billFromDate: item.billFromDate ? toDisplayFormat(item.billFromDate) : "",
        chargeId: item.chargeId,
      }));
  }

  const pageSizeOptions = {
    20: 20,
    50: 50,
    100: 100,
  };

  const renderFooter = () => {
    const handleExport = async (payments) => {
      const { display_name: author } = jwtDecode(AuthService.getCurrentUser());
      const columnKeyList = filterColumns.map(({ key }) => key);
      const header = [
        { name: "clientFullName", title: "Клиент", type: "String" },
        { name: "serviceTypeName", title: "Тип продукта", type: "String" },
        { name: "rateMode", title: "Вид цены", type: "String" },
        { name: "offeringName", title: "Предложение", type: "String" },
        { name: "rateTypeId", title: "Тип цены", type: "String" },
        { name: "period", title: "Период", type: "String" },
        { name: "chargePrice", title: "Цена", type: "Double" },
        { name: "chargeUnits", title: "Количество", type: "Double" },
        { name: "chargeAmount", title: "Сумма", type: "Double" },
        { name: "chargeName", title: "Номенклатура", type: "String" },
        {
          name: "adjustmentTypeId",
          title: "Начисление/Корректировка",
          type: "String",
        },
        { name: "invoiceExtNum", title: "Номер СФ", type: "String" },
        { name: "billNumber", title: "Номер счета", type: "String" },
        { name: "invoicePayStatus", title: "Статус СФ", type: "String" },
        { name: "invoiceAmount", title: "Сумма СФ", type: "String" },
        { name: "invoicePeriod", title: "Период СФ", type: "String" },
        { name: "invoiceDate", title: "Дата СФ", type: "String" },
        {
          name: "billPayStatus",
          title: "Статус оплаты счета",
          type: "String",
        },
        { name: "billAmount", title: "Сумма счета", type: "Double" },
        { name: "billPeriod", title: "Период счета", type: "String" },
        { name: "billFromDate", title: "Дата счета", type: "String" },
      ].filter(({ name }) => columnKeyList.includes(name));

      const filteredData = payments.map((detail) => {
        const period = [
          detail.chargePeriodFrom ? toDisplayFormat(detail.chargePeriodFrom) : "",
          detail.chargePeriodTo ? toDisplayFormat(detail.chargePeriodTo) : "",
        ].join(" - ");
        const invoicePeriod = [
          detail.invoicePeriodFrom ? toDisplayFormat(detail.invoicePeriodFrom) : "",
          detail.invoicePeriodTo ? toDisplayFormat(detail.invoicePeriodTo) : "",
        ].join(" - ");
        const billPeriod = [
          detail.billPeriodFrom ? toDisplayFormat(detail.billPeriodFrom) : "",
          detail.billPeriodTo ? toDisplayFormat(detail.billPeriodTo) : "",
        ].join(" - ");
        return pick(
          {
            clientFullName: detail?.clientFullName || String(detail.accountId) || "",
            serviceTypeName:
              !detail?.serviceTypeName && detail.isAdjustment === 1
                ? detail?.chargeName
                : detail?.serviceTypeName,
            rateMode: detail?.rateMode,
            offeringName: detail?.offeringName,
            rateTypeId: rateType.find((find) => find?.id === detail.rateTypeId)?.name || null,
            period,
            chargePrice: detail?.chargePrice,
            chargeUnits: detail?.chargeUnits,
            chargeAmount: detail?.chargeAmount && round(detail?.chargeAmount),
            chargeName: detail?.chargeName,
            adjustmentTypeId:
              Number(detail?.adjustmentTypeId) === 0 ? "Начисление" : "Корректировка",
            invoiceExtNum: detail?.invoiceExtNum,
            billNumber: detail?.billNumber,
            invoicePayStatus: detail?.invoicePayStatus,
            invoiceAmount: detail?.invoiceAmount && round(detail?.invoiceAmount),
            invoicePeriod,
            invoiceDate: detail?.invoiceDate ? toDisplayFormat(detail?.invoiceDate) : "",
            billPayStatus: detail?.billPayStatus,
            billAmount: detail?.billAmount && round(detail?.billAmount),
            billPeriod,
            billFromDate: detail?.billFromDate ? toDisplayFormat(detail?.billFromDate) : "",
          },
          columnKeyList
        );
      });

      const exportedData = {
        fileName: `Начисления_${formatDate.toDisplayFormat(moment())}`,
        title: "Выгрузка данных в формате xls",
        description: "Выгрузка данных",
        author,
        header,
        data: filteredData,
      };
      await dispatch(exportToXLS(exportedData)).finally(stopLoading);
    };

    const handleExportSelected = () => {
      startLoading();
      const selectedPayments =
        (data && data.filter((item) => selectedRowKeys.includes(item.serialNumber))) || [];
      handleExport(selectedPayments);
    };

    const handleExportAll = () => {
      startLoading();
      fetchChargesAll()
        .then((paymentsAll) => {
          handleExport(paymentsAll);
        })
        .catch(stopLoading);
    };

    return (
      <Space className="buttons-container">
        {hasAccess(MENU_CHARGES_WRITE) && (
          <>
            <Button
              type="primary"
              disabled={selectedRowKeys.length === 0 || !filterColumns.length}
              loading={isLoading}
              onClick={handleExportSelected}
            >
              Выгрузить в XLS (выбранное)
            </Button>
            <Button
              type="primary"
              disabled={isEmpty(tableData) || !filterColumns.length}
              loading={isLoading}
              onClick={handleExportAll}
            >
              Выгрузить в XLS (все)
            </Button>
          </>
        )}
      </Space>
    );
  };

  const onSearch = (values) => {
    if (values) {
      if (values["organization.property.stringValue"]) {
        values["organization.property.typeId"] =
          companyIdentityAttribute && companyIdentityAttribute;
      }
      values.page = 0;
      values.size = chargeParams.size;
      values.chargeDateFrom = toHttpFormatStartOfDay(values.chargeDate[0]);
      values.chargeDateTo = toHttpFormatEndOfDay(values.chargeDate[1]);
      values.chargePeriodFrom = toHttpFormatStartOfDay(values.chargePeriod[0]);
      values.chargePeriodTo = toHttpFormatEndOfDay(values.chargePeriod[1]);

      values.invoiceDateFrom =
        values.invoiceDate && values.invoiceDate[0]
          ? toHttpFormatStartOfDay(values.invoiceDate[0])
          : "";
      values.invoiceDateTo =
        values.invoiceDate && values.invoiceDate[1]
          ? toHttpFormatEndOfDay(values.invoiceDate[1])
          : "";

      values.billDateFrom =
        values.billDate && values.billDate[0] ? toHttpFormatStartOfDay(values.billDate[0]) : "";
      values.billDateTo =
        values.billDate && values.billDate[1] ? toHttpFormatEndOfDay(values.billDate[1]) : "";

      values.billPeriodFrom =
        values.billPeriod && values.billPeriod[0]
          ? toHttpFormatStartOfDay(values.billPeriod[0])
          : "";
      values.billPeriodTo =
        values.billPeriod && values.billPeriod[1] ? toHttpFormatEndOfDay(values.billPeriod[1]) : "";

      values.chargeIds = values.chargeIds
        ? values.chargeIds.split(/\D/).filter(Boolean).map(Number)
        : "";

      values.chargeDate = "";
      values.chargePeriod = "";
      values.invoiceDate = "";
      values.billDate = "";
      values.billPeriod = "";
    }
    setSelectedRowKeys([]);
    handleSearchCharges(values, clientType);
  };

  return (
    <>
      <div className="inner-row" style={{ height: "50px" }}>
        <Row justify="space-between" align="middle">
          <Col>
            <h1>Массовые операции по работе с начислениями</h1>
          </Col>
        </Row>
      </div>
      <ChargesSearchFilters
        defaultSearchParams={chargesSearchParams}
        form={form}
        onSearch={onSearch}
        resetSearchPaymentsAndResetSetSelectedRowKeys={
          resetSearchPaymentsAndResetSetSelectedRowKeys
        }
        filtersCollapseState={filtersCollapseState}
        setFiltersCollapseState={setFiltersCollapseState}
        clientType={clientType}
        setClientType={setClientType}
      />
      <Row justify="end" align="middle" className=" account-detalization__pagination">
        <Col style={{ paddingLeft: "8px" }} span={6}>
          <Checkbox onChange={toggleZeroCharges} style={{ color: "#5D6C7A" }} checked={checked}>
            Скрывать нулевые начисления
          </Checkbox>
        </Col>
        <Col span={12}>
          <Row justify="center">
            <Pagination
              onChange={(e) => handlePageSize("page", e)}
              current={getValueChargesPagingAndFilters("page") + 1}
              total={chargesData && chargesData?.totalElements}
              pageSize={getValueChargesPagingAndFilters("size")}
              hideOnSinglePage
              size="small"
              showSizeChanger={false}
            />
          </Row>
        </Col>
        <Col span={6} style={{ paddingRight: "5px" }}>
          <Row justify="end" align="middle" wrap={false}>
            <Col style={{ marginRight: "15px" }}>
              <TablePageSelect
                onChange={(e) => handlePageSize("size", e)}
                value={getValueChargesPagingAndFilters("size")}
                pageSizeOptions={pageSizeOptions}
              />
            </Col>
            <ToggleColumns tableName="charges-table" columns={columns} setColumns={setColumns} />
          </Row>
        </Col>
      </Row>
      <div className="charges-table">
        <Table
          size="small"
          columns={filterColumns}
          loading={checkIsLoading(chargesDataLoading)}
          dataSource={tableData}
          pagination={false}
          scroll={{ y: getTableHeight(), x: true }}
          rowSelection={{
            selectedRowKeys,
            onChange: (selectedKeys) => {
              setSelectedRowKeys(selectedKeys);
            },
          }}
          onRow={(record) => ({
            onClick: (e) => {
              e.stopPropagation();
              sessionStorage.setItem(
                "chargeFilters",
                JSON.stringify({
                  path: url,
                  chargeParams: { ...chargeParams, clientType },
                  chargeColumns,
                })
              );
              history.push(`/charges-details/${record.chargeId}`);
            },
          })}
        />
      </div>

      {renderFooter()}
    </>
  );
};

export default Charges;
